// test45
(45 && 0);
